(function () {
    'use strict';
    var $ = window.jQuery;
    var sport = null;
    var currentMonth = null;

    function MasterSchedules(options) {
        if (!options) {
            throw new Error('No options passed to MasterSchedules constructor');
        }

        this.options = $.extend({}, MasterSchedules.defaults, options);

        this.initLoadMoreButton();
        this.initNextMonthButton();
        this.initPreviousMonthButton();
        this.initSportDropdownList();
        initEventClickButton();
    }

    function initEventClickButton() {
        // Open event on Calendar View
        var calendarViewSelector = $('.calendar-view');
        if (calendarViewSelector.length) {
            $('.calendar-view .event > a').click(function (e) {
                e.preventDefault();
                e.stopPropagation();

                $('.calendar-view .event > a').removeClass('active');
                $('.calendar-view .event').removeClass('opened');
                $('.calendar-view .overview').fadeOut(300);

                if ($(this).parent().hasClass('opened')) {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('opened');
                    $(this).parent().find('.overview').fadeOut(300);
                } else {
                    $(this).addClass('active');
                    $(this).parent().addClass('opened');
                    $(this).parent().find('.overview').fadeIn(300);
                }
            });

            $('.calendar-view .overview').click(function (e) {
                e.stopPropagation();
            });

            $(document).click(function () {
                $('.calendar-view .event > a').removeClass('active');
                $('.calendar-view .event').removeClass('opened');
                $('.calendar-view .overview').fadeOut(300);
            });
        }
    }

    MasterSchedules.prototype.initLoadMoreButton = function () {
        var loadButton = $('#loadMore');

        sport = $("#sport_select option:selected").val();

        loadButton.on('click', function (e) {
            if ($(this).hasClass('isDisabled')) {
                e.preventDefault();
            } else {
                e.preventDefault();
                var offset = $(this).data('offset');

                $(this).prop('disabled', true).addClass('isDisabled');
                listRequest(offset, false);
            }
        });
    };

    MasterSchedules.prototype.initNextMonthButton = function () {
        var monthButton = $('#next_month');

        monthButton.on('click', function (e) {
            if ($(this).hasClass('disabled')) {
                e.preventDefault();
            } else {
                e.preventDefault();
                currentMonth = $(this).data('to-month');
                calendarRequest();
            }
        });
    };

    MasterSchedules.prototype.initPreviousMonthButton = function () {
        var monthButton = $('#previous_month');

        monthButton.on('click', function (e) {
            if ($(this).hasClass('disabled')) {
                e.preventDefault();
            } else {
                e.preventDefault();
                currentMonth = $(this).data('to-month');
                calendarRequest();
            }
        });
    };

    MasterSchedules.prototype.initSportDropdownList = function () {
        $('#sport_select').on('change', function () {
            sport = $(this).val();
            listRequest(0, true);
            calendarRequest();
        });
    };

    function listRequest(offset, reset) {
        var loadButton = $('#loadMore'),
            loadButtonWrapper = $('.load-more');
        var request_data = {'offset': offset};

        if (sport) {
            request_data.sport = sport;
        }

        $.ajax({
            type: 'GET',
            url: '/wp-json/arkansas/v2/master_schedules',
            data: request_data,
            success: function (response) {
                if (response.count > 0 || reset) {
                    offset += response.count;
                    if (reset) {
                        $('#schedules_content').empty().append(response.data);
                    } else {
                        $('#schedules_content').append(response.data);
                    }
                    loadButton.data('offset', offset).prop('disabled', false).removeClass('isDisabled');
                }
                if (response.is_full) {
                    if (response.count === 0 && reset) {
                        $('#schedules_content').append('<h2>Events not found</h2>');
                    }
                    loadButtonWrapper.fadeOut();
                } else {
                    loadButtonWrapper.fadeIn();
                }
            },
            error: function (data) {
            }
        });
    }

    function calendarRequest() {

        var date = {};

        if (currentMonth) {
            date.date = currentMonth;
        }

        if (sport) {
            date.sport = sport;
        }

        $.ajax({
            type: 'GET',
            url: '/wp-json/arkansas/v2/master_schedules_calendar',
            data: date,
            beforeSend: function () {
                $('#previous_month').addClass('disabled');
                $('#next_month').addClass('disabled');
            },
            complete: function () {
                $('#previous_month').removeClass('disabled');
                $('#next_month').removeClass('disabled');
            },
            success: function (response) {
                $('#calendar_content').empty().append(response.data);
                $('#previous_month').data('to-month', response.prev_month);
                $('#current_month').empty().append(response.current_month);
                $('#next_month').data('to-month', response.next_month);
                initEventClickButton();
            },
            error: function (data) {
            }
        });
    }

    window.MasterSchedules = MasterSchedules;
}());
